import { render, staticRenderFns } from "./dashboard-head.vue?vue&type=template&id=466d0b34"
import script from "./dashboard-head.vue?vue&type=script&lang=js"
export * from "./dashboard-head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports